import { BinaryOptionType } from '../types/binaryOption';

export const isBinaryOptionDefault = (
  optionLabel: BinaryOptionType,
  defaultValue: boolean | null | undefined,
) => {
  switch (optionLabel) {
    case 'Yes':
      return defaultValue === true;
    case 'No':
      return defaultValue === false;
    default:
      return false;
  }
};
